import {
  getApiErrorStatus,
  getApiProblemErrors,
} from "Infrastructure/Api/ApiUtils";
import { HttpStatusCode } from "Models/HttpStatusCodes";

const AFFILIATE_CODE_ERRORS = [
  "AffiliateCodeNotFound",
  "AffiliateCodeOwn",
  "AffiliateCodeNotApplicable",
  "AffiliateReferrerAlreadySet",
  "AffiliateReferrerTooLate",
] as const;

export type AffiliateCodeError =
  | (typeof AFFILIATE_CODE_ERRORS)[number]
  | "TooManyRequests"
  | "Unavailable"
  // A typed code the form was submitted with before it was verified.
  | "Unverified";

export const getAffiliateCodeError = (error: unknown): AffiliateCodeError => {
  if (getApiErrorStatus(error) === HttpStatusCode.TooManyRequests) {
    return "TooManyRequests";
  }

  const errors = getApiProblemErrors(error);

  return (
    (errors && AFFILIATE_CODE_ERRORS.find((key) => key in errors)) ??
    "Unavailable"
  );
};
